"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RowRenderer = exports.ITEM_SIZE = exports.DEFAULT_HEIGHT = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactWindow = require("react-window");
var _itemText = _interopRequireDefault(require("./item-text"));
var _styles = require("./styles");
// Calculated height of an <Item/> with text as the child
const ITEM_SIZE = exports.ITEM_SIZE = 36;
const DEFAULT_HEIGHT = exports.DEFAULT_HEIGHT = 200;
const propTypes = {
  /**
   * The list of items that can be selected from: either a list of strings or a list of objects.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number])),
  /**
   * A number that sets the max height of the dropdown in pixels (e.g. 100)
   * If all items do not fit the user will need to scroll to see additional options.
   * If less than or equal to 5 items are provided the dropdown will fit to size.
   *
   * Default: 200
   */
  maxHeight: _propTypes.default.number,
  /**
   * The current input value of the Select
   * Provided by downshift render prop
   */
  inputValue: _propTypes.default.string.isRequired,
  /**
   * Returns the props you should apply to any menu item elements you render.
   * Provided by downshift render prop
   */
  getItemProps: _propTypes.default.func.isRequired,
  /**
   * Function defining how the item text should be rendered.
   * Only necessary when the list of items passed in are objects.
   * Example: if items are of the format {id: 1, text: 'apple'},
   * you would want itemToString to be: (item) => item ? item.text : ''
   */
  itemToString: _propTypes.default.func,
  /**
   * The currently highlighted index
   */
  highlightedIndex: _propTypes.default.number,
  useTypeahead: _propTypes.default.bool,
  truncate: _propTypes.default.bool,
  itemToElement: _propTypes.default.func,
  itemToKey: _propTypes.default.func
};
const defaultProps = {
  items: []
};

/**
 * Responsible for rendering each row of the virtualized list
 */
const RowRenderer = _ref => {
  let {
    style,
    index,
    data
  } = _ref;
  // I don't love this API as it overloads the data prop a bit, but it's
  // done like this in the official Downshift examples so I can live w/it
  // https://codesandbox.io/s/github/kentcdodds/downshift-examples
  const {
    items,
    inputValue,
    getItemProps,
    itemToString,
    itemToElement,
    itemToKey,
    highlightedIndex,
    useTypeahead,
    truncate
  } = data;
  const item = items[index];
  return /*#__PURE__*/_react.default.createElement("div", {
    style: style
  }, /*#__PURE__*/_react.default.createElement(_styles.Item, getItemProps({
    item,
    index,
    isActive: highlightedIndex === index,
    key: itemToKey ? itemToKey(item) : itemToString(item)
  }), itemToElement ?
  // TODO - make it so customly tall items don't overlap (KENG-8004)
  itemToElement(item, inputValue) : /*#__PURE__*/_react.default.createElement(_itemText.default, {
    inputValue: inputValue,
    useTypeahead: useTypeahead,
    truncate: truncate
  }, itemToString(item))));
};

/**
 * Renders a list of items using list virtualization/windowing.
 * Useful for lists with many elements that would otherwise slow down the page.
 */
exports.RowRenderer = RowRenderer;
const VirtualizedItems = _ref2 => {
  let {
    items = [],
    maxHeight,
    inputValue,
    useTypeahead,
    truncate,
    getItemProps,
    itemToString,
    itemToElement,
    itemToKey,
    highlightedIndex
  } = _ref2;
  const height = Math.min(items.length * ITEM_SIZE, maxHeight || DEFAULT_HEIGHT);
  return /*#__PURE__*/_react.default.createElement(_reactWindow.FixedSizeList, {
    width: '100%',
    height: height,
    itemSize: ITEM_SIZE,
    itemCount: items.length,
    itemData: {
      items,
      inputValue,
      getItemProps,
      itemToString,
      itemToElement,
      itemToKey,
      highlightedIndex,
      useTypeahead,
      truncate
    }
  }, RowRenderer);
};
VirtualizedItems.propTypes = propTypes;
VirtualizedItems.defaultProps = defaultProps;
var _default = exports.default = VirtualizedItems;
RowRenderer.__docgenInfo = {
  "description": "Responsible for rendering each row of the virtualized list",
  "methods": [],
  "displayName": "RowRenderer"
};
VirtualizedItems.__docgenInfo = {
  "description": "Renders a list of items using list virtualization/windowing.\nUseful for lists with many elements that would otherwise slow down the page.",
  "methods": [],
  "displayName": "VirtualizedItems",
  "props": {
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The list of items that can be selected from: either a list of strings or a list of objects.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false
    },
    "maxHeight": {
      "description": "A number that sets the max height of the dropdown in pixels (e.g. 100)\nIf all items do not fit the user will need to scroll to see additional options.\nIf less than or equal to 5 items are provided the dropdown will fit to size.\n\nDefault: 200",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "inputValue": {
      "description": "The current input value of the Select\nProvided by downshift render prop",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "getItemProps": {
      "description": "Returns the props you should apply to any menu item elements you render.\nProvided by downshift render prop",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "itemToString": {
      "description": "Function defining how the item text should be rendered.\nOnly necessary when the list of items passed in are objects.\nExample: if items are of the format {id: 1, text: 'apple'},\nyou would want itemToString to be: (item) => item ? item.text : ''",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "highlightedIndex": {
      "description": "The currently highlighted index",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "useTypeahead": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "truncate": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "itemToElement": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "itemToKey": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};